// eslint-disable-next-line
import { h, Component } from 'preact';
import Portal from 'preact-portal';
import PropTypes from 'prop-types';

import JoButtonGray from './components/JoButtonGray';
import JoButtonGreen from './components/JoButtonGreen';
import JoCloseWarningPopup from './components/JoCloseWarningPopup';

// import CSSTransitionGroup from 'preact-css-transition-group';

import { BTS_THUMBNAIL, BTS_EXPANDED, BTS_TROUBLESHOOTING, BTS_LIVE_AGENT_CHAT } from './consts';

window.JO_TIME_BEFORE_EXPAND =
    typeof window.JO_TIME_BEFORE_EXPAND !== 'undefined' ? window.JO_TIME_BEFORE_EXPAND : 2000;

class JoButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isMobile: false,
            buttonState: BTS_THUMBNAIL,
            autoExpand: true,
            showCloseConfirmation: false,
        };

        window.JOBTN = this;

        window.joEventCallback = ev => {
            switch (ev.action) {
                case 'OPEN':
                    this.setState({ buttonState: BTS_TROUBLESHOOTING });
                    break;

                case 'CLOSE':
                    this.setState({ showCloseConfirmation: true });
                    // this.setState({ buttonState: BTS_THUMBNAIL });
                    break;

                case 'MINIMIZE':
                    this.joEl = ev.element;
                    this.joEl.style.display = 'none';
                    this.setState({ buttonState: BTS_TROUBLESHOOTING });
                    break;

                default:
                    console.error('UNKNNOWN action: ', ev);
                    break;
            }

            if (ev.action === 'OPEN') {
                this.setState({ buttonState: BTS_TROUBLESHOOTING });
            }
        };
        this.isMouseEventsBlocked = false;
    }

    isRunningChat = () =>
        this.state.buttonState === BTS_TROUBLESHOOTING ||
        this.state.buttonState === BTS_LIVE_AGENT_CHAT;

    handleClick = () => {
        if (this.isRunningChat()) {
            window.joMaximizeChat();
        } else if (window.joOpenChat) {
            window.joOpenChat();

            if (this.state.buttonState === BTS_EXPANDED) {
                this.setButtonTo(BTS_THUMBNAIL);
            }
        }
    };

    setButtonTo = (newBtnState, done = () => {}) => {
        clearTimeout(this.autoExpandTimeout);

        const updater = {
            buttonState: newBtnState,
            autoExpand: false,
        };

        this.setState(updater, done);
    };

    handleMouseEnter = () => {
        if (this.isMouseEventsBlocked) {
            return;
        }
        switch (this.state.buttonState) {
            case BTS_THUMBNAIL:
                this.setButtonTo(BTS_EXPANDED);
                break;
            default:
                break;
        }
    };
    handleMouseLeave = () => {
        if (this.state.autoExpand) return;
        this.isMouseEventsBlocked = false;
        switch (this.state.buttonState) {
            case BTS_EXPANDED:
                this.setButtonTo(BTS_THUMBNAIL);
                break;
            default:
                break;
        }
    };

    handleCloseClick = ev => {
        this.isMouseEventsBlocked = true;
        ev.stopPropagation();
        this.setButtonTo(BTS_THUMBNAIL, () => {
            this.isMouseEventsBlocked = false;
        });
    };

    mqHandler = mediaObject => {
        this.setState({
            isMobile: !mediaObject.matches,
        });
    };

    handleForceCloseClick = () => {
        window.joCloseChat();
        this.setState({
            buttonState: BTS_THUMBNAIL,
            showCloseConfirmation: false,
        });
    };

    handlePopupClose = () => {
        this.setState({
            showCloseConfirmation: false,
        });
    };

    handleCloseFromChatState = ev => {
        ev.stopPropagation();
        this.setState({
            showCloseConfirmation: true,
        });
    };

    autoExpand = () => {
        this.autoExpandTimeout = setTimeout(() => {
            this.setState({
                buttonState: BTS_EXPANDED,
            });
        }, window.JO_TIME_BEFORE_EXPAND);
    };

    componentDidMount() {
        if (document.readyState === 'complete') {
            this.autoExpand();
        } else {
            window.addEventListener('load', this.autoExpand);
        }

        this.mediaQueryObject = window.matchMedia('(min-width: 720px)');
        this.mediaQueryObject.addListener(this.mqHandler);
        this.mqHandler(this.mediaQueryObject);
    }

    componentWillUnmount() {
        this.mediaQueryObject.removeListener(this.mqHandler);
    }

    render() {
        const { buttonState, showCloseConfirmation } = this.state;

        const joBtnProps = {
            buttonState,
            showCloseConfirmation,
            isRunningChat: this.isRunningChat(),
            isMobile: this.state.isMobile,
            handleClick: this.handleClick,
            handleMouseEnter: this.handleMouseEnter,
            handleMouseLeave: this.handleMouseLeave,
            handleCloseFromChatState: this.handleCloseFromChatState,
            handlePopupClose: this.handlePopupClose,
            handleForceCloseClick: this.handleForceCloseClick,
            handleCloseClick: this.handleCloseClick,
            autoExpand: this.state.autoExpand,
            isBannerShow: this.props.isBannerShow,
        };

        return (
            <div>
                <JoButtonGreen {...joBtnProps} />

                {showCloseConfirmation ? (
                    <Portal into="body">
                        <JoCloseWarningPopup
                            onClose={this.handlePopupClose}
                            onConfirm={this.handleForceCloseClick}
                        />
                    </Portal>
                ) : null}
            </div>
        );

        // const buttonWrapperClasses = classNames({
        //     [styles.joButtonWrapper]: true,
        // });
        // const chatButtonClasses = classNames({
        //     [styles.joButton]: true,
        //     [styles.joButtonInChatState]: this.isRunningChat(),
        // });
        // const helpPanelClasses = classNames({
        //     [styles.needHelpPanel]: true,
        //     [styles.expanded]: buttonState === BTS_EXPANDED,
        // });

        // const resumeTsPanelClasses = classNames({
        //     [styles.resumeTroubleshootingPanel]: true,
        //     [styles.expanded]: buttonState === BTS_TROUBLESHOOTING,
        // });

        // const nonChatState = buttonState === BTS_THUMBNAIL || buttonState === BTS_EXPANDED;
        // const chatState =
        //     buttonState === BTS_TROUBLESHOOTING || buttonState === BTS_LIVE_AGENT_CHAT;

        // const resumeTsPanelClickHandle = this.state.isMobile ? this.handleClick : () => {};

        // return (
        //     <div
        //         onMouseEnter={this.handleMouseEnter}
        //         onMouseLeave={this.handleMouseLeave}
        //         className={buttonWrapperClasses}
        //         {...this.props}
        //     >
        //         {nonChatState ? (
        //             <div className={helpPanelClasses}>
        //                 <div className={styles.needHelpPanelInnerWrap}>
        //                     <span>
        //                         Need help with your <strong>Back-UPS</strong>?
        //                     </span>
        //                     <IconClose fill="#333" onClick={this.handleCloseClick} />
        //                 </div>
        //             </div>
        //         ) : null}
        //         <button onClick={this.handleClick} className={chatButtonClasses} aria-label="">
        //             <IconBot fill="#fff" />
        //         </button>
        //         {/* <CSSTransitionGroup component="div" transitionName="resume-ts-panel"> */}
        //         {chatState ? (
        //             <div onClick={resumeTsPanelClickHandle} className={resumeTsPanelClasses}>
        //                 <div className={styles.resumeTroubleshootingPanelInnerWrap}>
        //                     {this.state.isMobile ? (
        //                         <span>Resume Troubleshooting</span>
        //                     ) : (
        //                         <ButtonResumeTs onClick={this.handleClick}>
        //                             Resume Troubleshooting
        //                         </ButtonResumeTs>
        //                     )}
        //                     <IconClose fill="#333" onClick={this.handleCloseFromChatState} />
        //                 </div>
        //             </div>
        //         ) : null}
        //         {/* </CSSTransitionGroup> */}
        //         {showCloseConfirmation ? (
        //             <Popup
        //                 onClose={this.handlePopupClose}
        //                 heading="Are you sure you wish to close the conversation?"
        //             >
        //                 <p>
        //                     You will lose all your progress with JO and will have to start over if
        //                     you decide to come back.
        //                 </p>
        //                 <button onClick={this.handleForceCloseClick}>Yes, please close JO</button>
        //             </Popup>
        //         ) : null}
        //     </div>
        // );
    }
}
JoButton.propTypes = {
    isBannerShow: PropTypes.bool,
};

export default JoButton;
